import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import history from '../../utils/history';
import injectReducer from '../../utils/injectReducer';
import { setFunnelStepAction } from '../App/actions';
import { STEP_NONE } from '../App/constants';
// Selectors
import { makeSelectLocale } from '../LanguageProvider/selectors';
// Actions
import { changePageIdAction, resetStateAction } from './actions';
// Constants
import { FAQ_URL, questionPropTypes } from './constants';
// Reducer & articles/categories data
import reducer, { faqArticles, faqCategories } from './reducer';
import makeSelectFaq, {
  selectArticlesList,
  selectCategoryName,
  selectFaqPage,
  selectRelatedQuestions,
} from './selectors';
import FaqView from './View';

export class Faq extends PureComponent {
  constructor(props) {
    super(props);
    if (this.checkPageId(this.props.match))
      this.props.changePageId(this.props.match.params.pageId);
  }

  componentDidMount() {
    this.props.setFunnelStep(STEP_NONE);
  }

  componentDidUpdate() {
    const { match } = this.props;
    if (
      this.checkPageId(match) && // We are checking if the url contains params
      match.params.pageId !== this.props.values.pageId // And if the pageId in the url is different with the pageId in the store
    ) {
      this.props.changePageId(match.params.pageId);
    }
  }

  componentWillUnmount() {
    this.props.resetState();
  }

  /**
   * @description Check if the url contains params
   * @param match: match object from react router
   * @returns {boolean} true or false
   */
  checkPageId = (match) => match && !isEmpty(match.params);

  /**
   * @description redirect to the Faq homepage
   */
  redirectHome = () => {
    this.props.resetState();
    history.push(FAQ_URL);
  };

  render() {
    return (
      <FaqView
        articlesList={this.props.articlesList}
        categoryName={this.props.categoryName}
        locale={this.props.locale}
        pageContent={this.props.selectFaqPage.content}
        pageType={this.props.selectFaqPage.type}
        redirectHome={this.redirectHome}
        relatedQuestions={this.props.relatedQuestions}
        resetState={this.props.resetState}
      />
    );
  }
}

Faq.propTypes = {
  articlesList: PropTypes.arrayOf(questionPropTypes),
  categoryName: PropTypes.string,
  changePageId: PropTypes.func,
  locale: PropTypes.string,
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    params: PropTypes.shape({
      pageId: PropTypes.string,
    }),
    path: PropTypes.string,
    url: PropTypes.string,
  }),
  relatedQuestions: PropTypes.arrayOf(questionPropTypes),
  resetState: PropTypes.func,
  selectFaqPage: PropTypes.shape({
    content: questionPropTypes,
    type: PropTypes.string,
  }),
  setFunnelStep: PropTypes.func.isRequired,
  values: PropTypes.exact({
    pageId: PropTypes.string,
    categoryName: PropTypes.string,
  }),
};

const mapStateToProps = createStructuredSelector({
  values: makeSelectFaq(),
  locale: makeSelectLocale(),
  selectFaqPage: selectFaqPage(faqCategories, faqArticles),
  articlesList: selectArticlesList(faqArticles),
  categoryName: selectCategoryName(faqCategories, faqArticles),
  relatedQuestions: selectRelatedQuestions(faqArticles),
});

export function mapDispatchToProps(dispatch) {
  return {
    changePageId: (pageId) => dispatch(changePageIdAction(pageId)),
    resetState: () => dispatch(resetStateAction()),
    setFunnelStep: (step) => dispatch(setFunnelStepAction(step)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'faq', reducer });

export default compose(withReducer, withConnect)(Faq);
